
import { useRouter, useRoute } from "vue-router";
import { defineComponent, onMounted, ref, watch } from "vue";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "filtro-base",
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "Filtros",
    },
    subtitle: {
      type: String,
      default: "",
    },
    modalWidth: {
      type: String,
      default: "500px",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showGoToBack: {
      type: Boolean,
      default: false,
    },
    hideFilter: {
      type: Boolean,
      default: false,
    },
    activeModal: {
      type: Boolean,
      default: false,
    },
    disabledClick: {
      type: Boolean,
      default: false,
    },
    closeModal: {
      type: Boolean,
      default: false,
    },
    openModal: {
      type: Function,
    },
  },
  emits: ["search"],
  setup(props, { emit }) {
    const modalFiltro: any = ref();
    const modalRefFiltro: any = ref();
    const modalDialogFiltro: any = ref();
    const hideClose: any = ref(false);
    const router = useRouter();

    // safety: only manipulate DOM if elements exist
    watch(
      () => props.disabledClick,
      () => {
        if (!modalDialogFiltro.value || !modalRefFiltro.value) return;
        try {
          if (!!props.disabledClick) {
            modalDialogFiltro.value.classList.add("abled-events");
            modalRefFiltro.value.classList.add("disabled-events");
          } else {
            modalDialogFiltro.value.classList.remove("abled-events");
            modalRefFiltro.value.classList.remove("disabled-events");
          }
        } catch (e) {
          console.error("FilterBase.disabledClick handler error:", e);
        }
      }
    );

    watch(
      () => props.activeModal,
      () => {
        if (props.activeModal) openModal(true);
      }
    );

    // dentro de setup(), substitua o watcher atual por este:

// keep a reference to the hidden handler so we can remove it later
    let _hiddenHandler: ((ev: Event) => void) | null = null;

    function cleanupModal() {
      try {
        // remove any stray backdrops
        document.querySelectorAll(".modal-backdrop").forEach((el) => el.parentElement?.removeChild(el));

        // restore body styles
        document.body.classList.remove("modal-open");
        document.body.style.paddingRight = "";
        document.body.style.overflow = "";

        // restore layout_content styles if modal was appended there
        const layoutContentEl = document.getElementById("layout_content");
        if (layoutContentEl) {
          layoutContentEl.classList.remove("modal-open");
          layoutContentEl.style.paddingRight = "";
          layoutContentEl.style.overflow = "";
        }

        // dispose modal instance to remove attached listeners and free state
        if (modalFiltro.value) {
          try {
            modalFiltro.value.dispose();
          } catch (e) {
            // ignore
          }
          modalFiltro.value = null;
        }
      } catch (e) {
        console.error("FilterBase.cleanupModal error:", e);
      }
    }

    watch(
      () => props.closeModal,
      () => {
        try {
          if (modalFiltro.value) {
            // hide modal, then rely on hidden.bs.modal to cleanup
            modalFiltro.value.hide();
          } else {
            // if no modal instance, still attempt cleanup
            cleanupModal();
          }
        } catch (e) {
          console.error("FilterBase.closeModal handler error:", e);
          // fallback cleanup
          setTimeout(cleanupModal, 200);
        }
      }
    );


    function goTo(routeName) {
      router.push({
        name: routeName,
      });
      try {
        modalFiltro.value && modalFiltro.value.hide();
      } catch (e) {
        console.error("Error hiding modal on goTo:", e);
      }
    }

    function openModal(staticModal = false) {
      try {
        modalDialogFiltro.value = document.getElementById(`filter-${props.id}-modal-dialog`);
        modalRefFiltro.value = document.getElementById(`filter-${props.id}-modal`);
        const layoutContent = document.getElementById("layout_content") || document.body;

        // if modal exists and is not already appended to the target, append it
        if (modalRefFiltro.value && layoutContent && modalRefFiltro.value.parentElement !== layoutContent) {
          layoutContent.appendChild(modalRefFiltro.value);
        }

        // create bootstrap modal instance safely
        if (staticModal) {
          modalFiltro.value = new Modal(modalRefFiltro.value, { keyboard: false, backdrop: "static" });
          hideClose.value = true;
        } else {
          modalFiltro.value = new Modal(modalRefFiltro.value);
          hideClose.value = false;
        }

        // remove existing hidden handler if any
        if (_hiddenHandler && modalRefFiltro.value && modalRefFiltro.value.removeEventListener) {
          modalRefFiltro.value.removeEventListener("hidden.bs.modal", _hiddenHandler);
        }

        // create a handler and attach it
        _hiddenHandler = () => {
          cleanupModal();
        };

        if (modalRefFiltro.value && modalRefFiltro.value.addEventListener) {
          modalRefFiltro.value.addEventListener("hidden.bs.modal", _hiddenHandler);
        }

        modalFiltro.value.show();

        // allow parent to react (optional callback)
        props.openModal && props.openModal();
      } catch (e) {
        console.error("FilterBase.openModal error:", e);
      }
    }

    function search() {
      emit("search");
    }

    return {
      openModal,
      search,
      hideClose,
      goTo,
    };
  },
});
